export default "__VITE_ASSET__DEWfBQLE__"